import { VaultFileView } from "../../../../models/view/vault-file/vault-file.view";
import { AccountTableView } from "@bitwarden/web-vault/app/models/types/account.types";

export class VaultFileDisplay {
  vaultFileContainerWidth: number = 0;
  filteredVaultFiles: VaultFileView[];
  displayVualtFiles: VaultFileView[];
  vaultFileViews: VaultFileView[];

  constructor() {}

  listFilteredFiles(accountId: string) {
    this.filteredVaultFiles = this.vaultFileViews?.filter((vaultFileView) =>
      vaultFileView.accountIds.includes(accountId),
    );
    this.displayVualtFiles = [];
    let curTextLength = 0;
    for (let i = 0; i < this.filteredVaultFiles?.length; i++) {
      const fileNameWidth = this.calculateFileItemWidth(this.filteredVaultFiles[i].name);
      if (curTextLength + fileNameWidth < this.vaultFileContainerWidth) {
        this.displayVualtFiles.push(this.filteredVaultFiles[i]);
        curTextLength += fileNameWidth;
      } else {
        break;
      }
    }
  }

  calculateFileItemWidth(fileName: string) {
    return 23 + (35 + 6 * fileName.length);
  }

  checkVaultItemsWraped() {
    return this.displayVualtFiles?.length < this.filteredVaultFiles?.length;
  }
}
